import { DeleteFilled, EditFilled } from '@ant-design/icons';
import { Button, Card, Col, Row } from 'antd';
import { LanguageContext } from 'contexts/LanguageContext';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { api } from 'services/api';
import '../../styles/template.css';
import CreateTemplate from './CreateTemplate';

const statusMap = {
	APPROVED: { label: 'Aprovado', icon: '🟢' },
	PENDING: { label: 'Pendente', icon: '🟡' },
	REJECTED: { label: 'Rejeitado', icon: '🔴' },
};

const categoryMap = {
	AUTHENTICATION: 'Autenticação',
	MARKETING: 'Marketing',
	UTILITY: 'Utilidade',
};

function TemplateItem({ token }) {
	const navigate = useNavigate();
	const { dictionary } = useContext(LanguageContext);
	const [templates, setTemplates] = useState([]);

	useEffect(() => {
		window.BX24.init(async () => {
			const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
			const domain = auth.domain;

			await getTemplates(domain);
		});
	}, []);

	const getTemplates = async (domain) => {
		const request = {
			params: {
				token,
				domain,
			},
		};

		try {
			const result = await api.get('getTemplates', request);
			setTemplates(result.data);
		} catch (error) {
			console.log('error:', error);
			setTemplates([]);
		}
	};

	return (
		<div className="template-item-container">
			<Row>
				<Card
					title={<FormattedMessage id="list_templates_title" />}
					extra={
						<Button onClick={() => navigate(`${process.env.PUBLIC_URL}/`)} type="primary">
							<FormattedMessage id="back_dashboard" />
						</Button>
					}
					className="template-card"
				>
					<Row>
						<CreateTemplate token={token} onTemplateList={() => getTemplates(domain)} />
					</Row>

					<div className="template-header">
						<Row>
							{['template_name', 'template_category', 'template_status', 'template_actions'].map(
								(id, index) => (
									<Col key={id} span={index === 3 ? 3 : 6} className="template-header-item">
										<FormattedMessage id={id} />
									</Col>
								),
							)}
						</Row>
					</div>

					{templates.map((template, index) => (
						<div className="template-body">
							<Row>
								<Col span={6} className="template-body-item">
									{template.name}
								</Col>
								<Col span={6} className="template-body-item">
									{categoryMap[template.category]}
								</Col>
								<Col span={6} className="template-body-item">
									{statusMap[template.status]?.label || template.status}{' '}
									{statusMap[template.status]?.icon}
								</Col>
								<Col span={6} className="template-body-actions" id="actions-col">
									<button className="btn-action btn-edit" onClick={() => {}}>
										<EditFilled />
										<p className="btn-text">{dictionary.edit}</p>
									</button>
									<button className="btn-action btn-delete" onClick={() => {}}>
										<DeleteFilled />
										<p className="btn-text">{dictionary.delete}</p>
									</button>
								</Col>
							</Row>
						</div>
					))}
				</Card>
			</Row>
		</div>
	);
}

export default TemplateItem;
